import { Component } from '@angular/core';
import { ResearchMemberDocumentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Member Documents') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-researchmemberdocument-form',
    templateUrl: './researchmemberdocument.form.component.html'
})
export class ResearchMemberDocumentFormComponent extends BaseFormComponent {
    public record!: ResearchMemberDocumentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'cvParses', sectionName: 'Cv Parses', isExpanded: false }
        ]);
    }
}

